import { IconPound } from '@iwoca/icons';
import { Input, Label, Tooltip } from '@iwoca/orion';
import { Controller, useFormContext } from 'react-hook-form';
import { useSignupData } from '../hooks/useSignupData';
import styles from '../SignupForm/SignupForm.module.css';
import { TSignupFormData } from '../SignupForm/SignupForm.types';

type TProps = {
  disabled: boolean;
};

export const TurnoverInput = ({ disabled }: TProps) => {
  const { isReintroduction } = useSignupData();
  const {
    control,
    formState: { errors },
  } = useFormContext<TSignupFormData>();

  return (
    <>
      <div
        className={
          isReintroduction
            ? styles.labelWithTooltipAndDescription
            : styles.labelWithTooltip
        }
      >
        <Label htmlFor="last12MonthsTurnover">Last 12 months turnover</Label>
        <Tooltip content="If they have been trading for less than a year, enter the total turnover to date." />
      </div>
      <Controller
        name="last12MonthsTurnover"
        control={control}
        render={({ field: { onChange, value } }) => {
          const numericValue = value?.replace(/[^0-9]/g, '') ?? '';
          const formattedValue = numericValue
            ? parseInt(numericValue).toLocaleString()
            : '';

          return (
            <Input
              id="last12MonthsTurnover"
              name="last12MonthsTurnover"
              description={
                isReintroduction
                  ? 'Enter the most up-to-date figure'
                  : undefined
              }
              type="text"
              iconLeft={<IconPound />}
              value={formattedValue}
              onChange={(e) => {
                const rawValue = e.target.value.replace(/[^0-9]/g, '');
                onChange(rawValue);
              }}
              disabled={disabled}
              error={
                errors?.last12MonthsTurnover?.message &&
                errors.last12MonthsTurnover.message
              }
            />
          );
        }}
      />
    </>
  );
};
